<template>
    <div>
        <v-toolbar dense style="margin-bottom: 25px;" height="90">
            <v-toolbar-title></v-toolbar-title>

            <v-menu
                    ref="menu"
                    v-model="filter"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">

                <template  v-slot:activator="{ on, attrs }">
                    <v-text-field style="margin-bottom: -3%"
                            v-model="date"
                            prepend-inner-icon="mdi-filter"
                            v-bind="attrs" readonly solo
                            v-on="on">
                    </v-text-field>
                </template>
                <v-date-picker  v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-toolbar>

        <v-card>
            <v-data-table
                    :headers="headers"
                    :items="journals"
                    :items-per-page="15"
                    :loading="!journals"
                    class="elevation-1"
            >
                <template v-slot:item._country_code="{item}">
                    <country-flag  :country="item._country_code" size='normal'/>
                </template>
                <template v-slot:item._created_at="{item}">
                    {{ new Date(item._created_at).toLocaleDateString()}}
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
//    import {mapState} from "vuex";

    import helpers from "../../mixins/helpers";
import {mapState} from "vuex";

export default {
        name: "DeveloperJournal",
        mixins:[helpers(this)],
        data (){
            return{
                date: new Date().toISOString().substr(0, 10),
                filter:false,
                search:'',
                headers: [
                    {
                        text: 'Client',
                        align: 'start',
                        sortable: false,
                        value: 'name',
                    },
                    { text: 'Péripherique', value: '_device' },
                    { text: 'Ip', value: '_ip' },
                  //  { text: 'Path', value: '_path' },
                    { text: 'Methode', value: '_method' },
                    { text: 'Pays', value: '_country_code' },
                    { text: 'Date', value: '_created_at' },
                ],

            }
        },
        computed:{
            ...mapState('payments',['journals'])
        },
        mounted() {
            let marchand = JSON.parse(sessionStorage.getItem("marchand"));
            let marchand_id = (marchand)?marchand._id:null;
            this.$store.dispatch('payments/getUserJournals',marchand_id)
        },
        methods: {},
    created() {
        this.checkisDashboard();
    },
    }

</script>

<style scoped>
    .circle-icon {
        background: #29B3A6;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin-top: -30%;
        margin-left: 53%;
    }
    .circular--square {
        border-radius: 50%;
    }
    .circular--square {
        border-radius: 50% 50%;
        width: 170px;
        height: 170px;
        object-fit: contain;
    }
    .img-icon-holder{
        margin-left: 60%;
        padding: 8px;
        background-color: #29B3A6;
        border-radius: 50%;
    }
    /*.circular--portrait {
        position: relative;
        width: 200px;
        height: 200px;
        overflow: hidden;
        border-radius: 50%;
    }

    .circular--portrait img {
        width: 100%;
        height: auto;
    }*/
</style>
